
  export default {
    name: 'BaseImg',
  };
